import {
  DELIVERY_DATE_CONTEXT_ISOLATED,
  DeliveryDateContext
} from '_common/context/DeliveryDateContext';
import { useAppSelector } from '_common/hooks/reduxHooks';
import ProducerCallout from '_consumer/components/producer/ProducerCallout';
import ProducerView from '_consumer/components/producer/ProducerView';
import { Page } from '@components/page';
import { Producer } from 'types/Producer';
import { ProductForSale } from 'types/Product';
import { isGuestConsumer } from 'utils/role';

type ProducerPageProps = {
  products: ProductForSale[];
  producer: Producer;
};

const ProducerPage = ({ products, producer }: ProducerPageProps) => {
  const { isGuest, isInSameDA, roleType, userId } = useAppSelector(
    ({ auth: { _id, authenticated, distributionAreaName, _type } }) => {
      return {
        isGuest: isGuestConsumer(_id) || !authenticated,
        isInSameDA:
          distributionAreaName &&
          producer.distributionAreas?.includes(distributionAreaName),
        roleType: _type,
        userId: _id
      };
    }
  );

  return (
    <DeliveryDateContext.Provider
      value={{ pageContext: DELIVERY_DATE_CONTEXT_ISOLATED }}
    >
      <Page>
        <ProducerCallout userId={userId} producer={producer} />
        <ProducerView
          producer={producer}
          products={products}
          roleType={roleType}
          isGuest={isGuest}
          isInSameDA={Boolean(isInSameDA)}
        />
      </Page>
    </DeliveryDateContext.Provider>
  );
};

export default ProducerPage;
